import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './SkipButton.scss'


// TODO get rid of ...props
const SkipButton = ({ modalName, className, ...props }) => (
  <Button
    className={cx(s.skipButton, className)}
    title={messages.title}
    halfPadding
    gray
    xlg
    onClick={() => {
      actions.models.modals.close(modalName)
      actions.models.modals.open(constants.modals.review.Recommendations)
    }}
    {...props}
  />
)

SkipButton.propTypes = {
  modalName: PropTypes.string,
}


export default SkipButton
